import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-local-loader',
  templateUrl: './local-loader.component.html',
  styleUrls: ['./local-loader.component.scss'],
})
export class LocalLoaderComponent {
  @Input() data!: string;
  @Input() isLoading: boolean | null = false;
}
